/**
* GENERATED BY KRPC GEN - LESS MODIFY BY HAND
* tech-service.ts  2025-08-28T16:37:17+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'krpc-base';

import type { TechTrainingCert, TechServiceTime, TechCompareRecResp, TechServiceStatusResp, TechServiceStatusReq, TechCompareRecReq } from './wy-dto';

const _ = 'Tech/';

export class TechService {

  constructor(readonly r: RpcService) {}
  // 技师的最近3个培训证书，按发证时间由新到旧
  getLast3TrainingCert(d:string, m?: M): R<Array<TechTrainingCert>>{
    return this.r.async(_ + 'getLast3TrainingCert', d, m);
  }
  // 技师对比推荐技师
  getTechCompareRec(d:TechCompareRecReq, m?: M): R<TechCompareRecResp>{
    return this.r.async(_ + 'getTechCompareRec', d, m);
  }
  // 获取技师当前服务状态
  getTechServiceStatus(d:TechServiceStatusReq, m?: M): R<TechServiceStatusResp>{
    return this.r.async(_ + 'getTechServiceStatus', d, m);
  }
  // 获取指定技师的服务时间列表
  getTechServiceTime(d:string, m?: M): R<Array<TechServiceTime>>{
    return this.r.async(_ + 'getTechServiceTime', d, m);
  }
}
